<!-- eslint-disable max-len -->
<!--- COMPONENTE PCUltimosPalesGenerados  ---->
<!---
Descripción del componente:
---------------------------
- Incluye una lista con los ultimos palés generados.

Eventos del componente:
-----------------------
-  xxxxxxxxxxx ->
--->
<template>
  <div class="main-ultimosPalesGenerados">
    <f7-row
      v-if="mostrarTitulo"
      class="block-title"
    >
      <f7-col width="90">
        <span>
          {{ $t('common.pallets') }}
        </span>
      </f7-col>
    </f7-row>
    <!-- Preloader de carga -->
    <UCPreload :show="mostrarPrecarga" />
    <!-- No existen registros de palés -->
    <!-- Registros de Palés -->
    <div class="div-registrosPales">
      <!-- Pale en curso -->
      <div
        v-if="paleEnCurso != null"
        class="div-registroPaleActivo"
      >
        <f7-row
          class="row-registroPale"
        >
          <f7-col
            width="5"
            class="col-indicadorEstadoPale"
          >
            <span class="inidicador-amarillo-8" />
          </f7-col>
          <f7-col
            width="95"
            style="padding-left: 6px;"
          >
            <f7-row class="no-padding">
              <f7-col width="100">
                <span
                  v-if="paleEnCurso.NumeroSerie"
                  class="span-texto-azulOscuro-22-500"
                >
                  {{ paleEnCurso.NumeroSerie }}
                </span>
              </f7-col>
            </f7-row>
            <f7-row class="no-padding">
              <f7-col width="100">
                <span class="span-texto-grisAzul-14-400">{{ paleEnCurso.Codigo_PuntoPaletizado }}</span>
              </f7-col>
            </f7-row>
          </f7-col>
        </f7-row>
      </div>

      <!-- Palés Finalizados -->
      <div
        v-for="(pale, i) in listadoPales"
        :key="i"
        class="div-registroPale"
      >
        <f7-row
          class="row-registroPale"
        >
          <f7-col
            width="5"
            class="col-indicadorEstadoPale"
          >
            <span class="inidicador-azul-8" />
          </f7-col>
          <f7-col
            width="45"
            style="padding-left: 6px;"
          >
            <f7-row class="no-padding">
              <f7-col width="100">
                <span
                  v-if="pale.NumeroSerie"
                  class="span-texto-azulOscuro-22-500"
                >
                  {{ pale.NumeroSerie }}
                </span>
              </f7-col>
            </f7-row>
            <f7-row class="no-padding">
              <f7-col width="100">
                <span class="span-texto-grisAzul-14-400">{{ pale.Codigo_PuntoPaletizado }}</span>
              </f7-col>
            </f7-row>
          </f7-col>
          <f7-col
            width="35"
            class="col-horaFinPale"
          >
            <div class="div-horaRegistroMovimiento gris">
              {{ FormatearFechaYHora(pale.FechaFabricacion_NumeroSerie) }}
            </div>
          </f7-col>
          <f7-col
            width="15"
            class="col-btnImpresion"
          >
            <div
              class="btn-base-azulOscuro-28 seleccionable"
              @click="ImprimirEtiquetaPale(pale)"
            >
              <img
                src="@/static/icons/ic_print.svg"
                alt="iconPrint"
                width="32px"
              >
            </div>
          </f7-col>
        </f7-row>
      </div> <!-- Fin registro -->
    </div> <!-- Fin Registros Activos -->

    <!-- Popup Más Pales Volcadas -->
    <f7-popup
      class="masPartidasVolcadas-popup hide-popup-scanner"
      :opened="popupMasPales"
      @popup:closed="CerrarMasPales()"
    >
      <f7-navbar
        :title="nombrePopupFrm"
        sliding
        :style="appTheme"
      >
        <f7-nav-right>
          <f7-link popup-close>
            <img
              class="padding-right-half"
              :src="icClose"
            >
          </f7-link>
        </f7-nav-right>
      </f7-navbar>
      <!-- Componente de Busqueda de Pales -->
      <PCBuscadorPaleConfeccionado
        v-if="mostrarBuscador != null && mostrarBuscador"
        :cargar-existencias-pale="true"
        :cargar-datos-pedido-venta-del-pale="true"
        :buscar-codigo-de-barras="ultimoCodigoDeBarrasLeido"
        @pale-establecido="PaleEstablecidoMedianteBusqueda"
      />
      <div class="div-ultimosPales">
        <div
          v-if="filtroActivo && listadoPalesTotales != null && listadoPalesTotales.length > 0"
          class="div-cabeceraFiltroActivo"
        >
          <span class="span-texto-grisAzul-22-400">
            {{ `${$t('common.filter')}:` }}
          </span>
          <span class="span-texto-grisAzul-22-600"> {{ listadoPalesTotales[0].NumeroSerie }} </span>
          <div
            class="btn-base-grisMedio-28 seleccionable btn-EliminarFiltradoDePales"
            @click="EliminarFiltradoDePales()"
          >
            <span>{{ $t('common.x') }}</span>
          </div>
        </div>

        <!-- Registros de Palés -->
        <div class="div-registrosPales padding-half">
          <div class="div-listadoPalesFinalizadosYPendientes">
            <!-- Pale en curso -->
            <div
              v-if="paleEnCurso != null"
              class="div-registroPaleActivo"
            >
              <f7-row class="row-registroPale">
                <f7-col
                  width="5"
                  class="col-indicadorEstadoPale"
                >
                  <span class="inidicador-amarillo-8" />
                </f7-col>
                <f7-col
                  width="95"
                  style="padding-left: 6px;"
                >
                  <f7-row class="no-padding">
                    <f7-col width="100">
                      <span class="span-texto-azulOscuro-22-500 no-padding">{{ paleEnCurso.NumeroSerie }}</span>
                    </f7-col>
                  </f7-row>

                  <f7-row class="no-padding">
                    <f7-col width="100">
                      <span class="span-texto-grisAzul-14-400 no-padding">{{ paleEnCurso.NombreProducto }}</span>
                    </f7-col>
                  </f7-row>
                  <f7-row class="no-padding">
                    <f7-col width="100">
                      <span class="span-texto-grisAzul-14-400 no-padding">{{ paleEnCurso.Codigo_PuntoPaletizado }}</span>
                    </f7-col>
                  </f7-row>
                </f7-col>
              </f7-row>
            </div>
            <UCPreload :show="mostrarPrecargaVerMas" />
            <!-- Palés Finalizados -->
            <div
              v-for="(pale, i) in listadoPalesTotales"
              :key="i"
              class="div-registroPale"
            >
              <!-- <pre> {{pale}} </pre> -->
              <f7-row class="row-registroPale no-padding">
                <f7-col
                  width="5"
                  class="col-indicadorEstadoPale"
                >
                  <span class="inidicador-azul-8" />
                </f7-col>
                <f7-col width="65">
                  <f7-row class="no-padding">
                    <f7-col width="100">
                      <span class="span-texto-azulOscuro-22-500 no-margin">{{ pale.NumeroSerie }}</span>
                    </f7-col>
                  </f7-row>
                  <f7-row class="no-padding">
                    <f7-col width="100">
                      <span class="span-texto-grisAzul-14-400 no-margin">{{ pale.NombreProducto }}</span>
                    </f7-col>
                  </f7-row>
                  <f7-row
                    v-if="pale.PedidoVenta_NombreCliente != null"
                    class="no-padding"
                  >
                    <f7-col width="100">
                      <span class="span-texto-grisAzul-14-400 no-margin">{{ pale.PedidoVenta_NombreCliente }}</span>
                    </f7-col>
                  </f7-row>
                  <f7-row
                    v-if="pale.PedidoVenta_Numero != null"
                    class="no-padding"
                  >
                    <f7-col width="100">
                      <span class="span-texto-grisAzul-14-400 no-margin">
                        {{ `${$t('common.salesOrderShort')}: ${pale.PedidoVenta_Serie}/${pale.PedidoVenta_Numero}-${pale.PedidoVenta_Orden}` }}
                      </span>
                    </f7-col>
                  </f7-row>
                  <f7-row
                    v-if="pale.NroEnvases != null"
                    class="no-padding"
                  >
                    <f7-col width="100">
                      <span class="span-texto-grisAzul-14-400 no-margin">
                        {{
                          $t('production.lastGeneratedPallets.labels.containers', {
                            quantity: pale.NroEnvases,
                          })
                        }}
                      </span>
                    </f7-col>
                  </f7-row>

                  <f7-row class="no-padding">
                    <f7-col width="100">
                      <span class="span-texto-grisAzul-14-400 no-margin">{{ pale.Codigo_PuntoPaletizado }}</span>
                    </f7-col>
                  </f7-row>
                </f7-col>
                <f7-col
                  width="30"
                  class=""
                >
                  <f7-row>
                    <f7-col
                      width="100"
                      class="col-horaFinPale"
                    >
                      <div class="div-horaRegistroMovimiento gris">
                        {{ FormatearFechaYHora(pale.FechaFabricacion_NumeroSerie) }}
                      </div>
                    </f7-col>
                  </f7-row>
                  <f7-row>
                    <f7-col
                      width="100"
                      class="col-btnsOpcionesPale"
                    >
                      <div
                        class="btn-base-azulOscuro-28 seleccionable"
                        @click="ImprimirEtiquetaPale(pale)"
                      >
                        <img
                          src="@/static/icons/ic_print.svg"
                          alt="iconPrint"
                          width="32px"
                        >
                      </div>
                      <div
                        v-if="pesajeFinPale"
                        class="btn-base-azulOscuro-28 seleccionable"
                        @click="ModificarPesaje(pale)"
                      >
                        <img
                          src="@/static/icons/ic_weight.svg"
                          alt="iconPrint"
                          width="20px"
                        >
                      </div>
                      <div
                        v-if="mostrarBtnRetrabajarPale"
                        class="btn-base-amarillo-28 seleccionable"
                        @click="ReabrirPaleConfeccionado(pale)"
                      >
                        <img
                          src="@/static/img/icon_pala.png"
                          alt="iconPala"
                          width="14px"
                        >
                      </div>
                      <div
                        v-if="mostrarBtnEliminarPale"
                        class="btn-base-rojo-28 seleccionable"
                        @click="SolicitudEliminarPaleConfeccionado(pale)"
                      >
                        <img
                          src="@/static/icons/ic_trash_white_2.svg"
                          alt="iconTrash"
                          width="14px"
                        >
                      </div>
                    </f7-col>
                  </f7-row>
                </f7-col>
              </f7-row>
            </div> <!-- Fin registro -->
          </div>
        </div> <!-- Fin registros -->
      </div>
      <!-- Componente de Escanear -->
      <UCCodeScanner
        ambito="PCUltimosPalesGenerados"
        :continuous-bar-code-reading="false"
        :auto-open-camera="true"
        :allow-manual-code-entry="true"
        @code-reading="LecturaDeCodigoDeBarrasBusquedaPale"
        @codigo-barras="LecturaDeCodigoDeBarrasBusquedaPale"
      />
    </f7-popup>
    <!-- Action Confirmación Eliminar Palé -->
    <UCConfirmation ref="componenteConfirmacionEliminarPale" />
    <!-- <UCConfirmacionGH
      ref="componenteConfirmacionEliminarPale"
      :abierto="actionConfirmarEliminarPale"
      titulo="ELIMINAR PALÉ"
      mensaje="Esta acción eliminara el palé seleccionado. ¿Deseas continuar con la acción?"
      @Confirmar="actionConfirmarEliminarPale = false; ConfirmacionEliminarPale()"
      @Cancelar="actionConfirmarEliminarPale = false ; paleSeleccionado = null"
    /> -->
    <PCSistemaPesado
      :open-weighing-reading="actionsWeighingReading"
      :weight="weight"
      :id-a-n-s="paleSeleccionado != null ? paleSeleccionado.Id_NumeroSerie : 0"
      @update-weight="ImprimirEtiquetaPale(paleSeleccionado)"
      @event-close="actionsWeighingReading = false"
    />
  </div>
</template>

<script>
import { mapState, mapWritableState } from 'pinia';
import { useTraceabilityStore } from '@/js/stores/traceability';
import { useSettingRef } from '@erpagroapp/settings';

import { Log, LogError } from '@/js/common/HIDebuggingSupport';
import ConexionTA from '@/js/services/traceability/APITraceability';
import { HiDateTimeSupport } from '@/js/common/HIConversionSupport';
import UCCodeScanner from '@/components/common/UCCodeScanner.vue';
import UCPreload from '@/components/common/UCPreload.vue';
import UCConfirmation from '@/components/common/UCConfirmation.vue';
import PCSistemaPesado from '@/components/production/traceability/PCSistemaPesado.vue';
import icClose from '@/static/icons/ic_close.svg';
import { callExecuteSPERP } from '@/js/services/APIErp';
import {
  HiNotification,
  PreloaderGH,
} from '@/js/common/HINotificationSupport';
import PCBuscadorPaleConfeccionado from './PCBuscadorPaleConfeccionado.vue';

export default {
  name: 'PCUltimosPalesGenerados',
  components: {
    UCPreload,
    PCBuscadorPaleConfeccionado,
    UCCodeScanner,
    UCConfirmation,
    PCSistemaPesado,
  },
  props: {
    mostrarTitulo: {
      type: Boolean,
      default: true,
    },
    mostrarBuscador: {
      type: Boolean,
      default: true, // Muestra el buscador de palé
    },
    mostrarBtnRetrabajarPale: {
      type: Boolean,
      default: true, // Muesta el boton de seleccion de palé para retrabajar.
    },
    mostrarBtnEliminarPale: {
      type: Boolean,
      default: true, // Muesta el boton de seleccion de palé para eliminar.
    },
    nombrePopupFrm: {
      type: String,
      default: '',
    },
  },

  emits: [
    'inicioCargaDatos',
    'finCargaDatos',
    'reabrirPaleConfeccionadoEnPuntoDePaletizado',
  ],

  data() {
    return {
      lineaProduccionSeleccionada: null,
      puntoPaletizadoSeleccionado: null,
      mostrarPrecarga: false, // Muestra el componente de carga del resumen.
      mostrarPrecargaVerMas: false, // Muestra el componente de carga del popup ver mas.
      listadoPales: null, // Contiene el listado Pales
      listadoPalesTotales: null, // Carga el listado de los X ultimos Palés cuando se pulsa en Ver más.
      paleSeleccionado: null, // Mantiene el palé seleccionado.
      popupMasPales: false, // Controla la apertura del popup  que muestra mas palés.
      filtroActivo: false, // Cuando se busca un palé se establece el filtro.
      ultimoCodigoDeBarrasLeido: '',
      actionsWeighingReading: false, // Abre el sistema de pesado
      weight: 0,
      icClose,
      pesajeFinPale: useSettingRef('Paletizado.FinPale.Pesaje'),
    };
  },
  computed: {
    ...mapState(useTraceabilityStore, [
      'puntoDePaletizadoSeleccionado',
      'lineaDeProduccionSeleccionada',
    ]),

    ...mapWritableState(useTraceabilityStore, ['paleEnCurso']),

    appTheme() {
      return {
        '--f7-navbar-text-color': '#fff',
      };
    },
  },

  methods: {
    /**
     * Refreshes the data in the component.
     * @public
     * @returns {void}
     */
    ActualizarDatos() {
      this.ObtenerLineaDeProduccionSeleccionada();
      this.ObtenerPuntoPaletizadoSeleccionado();
      if (this.puntoPaletizadoSeleccionado != null) {
        this.ObtenerResumenPalesGenerados();
      }
    },

    RestablecerValores() {
      this.listadoPales = null;
      this.listadoPalesTotales = null;
      this.paleEnCurso = null;
    },

    ObtenerPuntoPaletizadoSeleccionado() {
      Log(this, this.ObtenerPuntoPaletizadoSeleccionado.name);
      this.puntoPaletizadoSeleccionado = this.puntoDePaletizadoSeleccionado;
    },

    ObtenerLineaDeProduccionSeleccionada() {
      Log(this, this.ObtenerLineaDeProduccionSeleccionada.name);
      this.lineaProduccionSeleccionada = this.lineaDeProduccionSeleccionada;
    },

    ObtenerResumenPalesGenerados() {
      Log(this, this.ObtenerResumenPalesGenerados.name);
      const self = this;
      self.mostrarPrecarga = true;
      self.$emit('inicioCargaDatos');
      this.RestablecerValores();
      self.ObtenerUltimosPalesConfeccionadosYEnConfeccion(10).then((result) => {
        self.listadoPales = self.ProcesarRespuestaPalesGeneradosParaResumen(result);
        self.mostrarPrecarga = false;
        self.$emit('finCargaDatos');
      }).catch((error) => {
        self.mostrarPrecarga = false;
        self.$emit('finCargaDatos');
        HiNotification.Toast(error);
      });
    },

    ProcesarRespuestaPalesGeneradosParaResumen(result) {
      Log(this, this.ProcesarRespuestaPalesGeneradosParaResumen.name);
      [this.paleEnCurso] = result.PalesEnCurso; // Por Punto de paletizado solo puede existir uno en curso.
      return result.PalesFinalizados;
    },

    FormatearFechaYHora(fechahoraMinutosSegundos) {
      return HiDateTimeSupport.FormatDateTime(fechahoraMinutosSegundos, 'DD/MM/YYYY HH:mm');
    },

    /**
     * @public
     * @returns {void}
     */
    VerMasPales() {
      Log(this, this.VerMasPales.name);
      this.popupMasPales = true;
      this.ActualizarListadoCompletoUltimosPalesGenerados();
    },

    ActualizarListadoCompletoUltimosPalesGenerados() {
      Log(this, this.ActualizarListadoCompletoUltimosPalesGenerados.name);
      const self = this;
      self.mostrarPrecargaVerMas = true;
      this.listadoPalesTotales = [];
      this.ObtenerUltimosPalesConfeccionadosYEnConfeccion(30).then((result) => {
        self.listadoPalesTotales = result.PalesFinalizados;
        self.mostrarPrecargaVerMas = false;
      }).catch((error) => {
        HiNotification.Toast(error);
        self.mostrarPrecargaVerMas = false;
      });
    },

    CerrarMasPales() {
      Log(this, this.CerrarMasPales.name);
      this.filtroActivo = false;
      this.popupMasPales = false;
      this.listadoPalesTotales = [];
    },

    ImprimirEtiquetaPale(paleSeleccionado) {
      Log(this, this.ImprimirEtiquetaPale.name);
      this.ImprimirEtiquetaPaleParaProcesoDePaletizado(paleSeleccionado.Id ? paleSeleccionado.Id : paleSeleccionado.Id_NumeroSerie).then(() => {
        HiNotification.Toast(this.$t('production.lastGeneratedPallets.printPalletLabel.successToastText'));
      }).catch((error) => {
        HiNotification.Toast(error);
      });
    },
    async ModificarPesaje(paleSelec) {
      Log(this, this.ModificarPesaje.name);
      this.paleSeleccionado = paleSelec;
      try {
        const result = await callExecuteSPERP(
          'APPTRAZABILIDAD_ArticulosNumerosSerie',
          [
            { NombreParametro: 'filtro', Valor: `numeroserie:${this.paleSeleccionado.NumeroSerie}` }, // Id, barcode, numeroserie
            { NombreParametro: 'idsGrupoEmpresarial', Valor: '' },
          ],
          'Almacen.UnidadContenedoraJSON',
        );
        if (result.data.length > 0) {
          this.weight = result.data[0].PesoBruto;
          this.actionsWeighingReading = true;
        } else {
          HiNotification.Toast(this.$t('production.lastGeneratedPallets.modifyWeight.noStockToastText', {
            serialNumber: this.paleSeleccionado.NumeroSerie,
          }));
        }
      } catch (error) {
        PreloaderGH(false);
        LogError(this, this.ModificarPesaje.name, error);
      }
    },

    ReabrirPaleConfeccionado(paleParaReabrir) {
      Log(this, this.ReabrirPaleConfeccionado.name);
      const self = this;

      if (this.paleEnCurso) {
        HiNotification.Toast(this.$t('production.lastGeneratedPallets.cannotReopenPalletInProcess'));
        return;
      }

      // Comprobamos si esta cargado los datos del producto, envase y palé
      if (Object.hasOwn(paleParaReabrir, 'Articulo')) {
        self.$emit('reabrirPaleConfeccionadoEnPuntoDePaletizado', paleParaReabrir);
        self.CerrarMasPales();
        PreloaderGH(false);
      } else {
        PreloaderGH(true, false, this.$t('production.lastGeneratedPallets.reopeningPallet.preloaderText'));
        this.ObtenerDetallesDelPale(paleParaReabrir.NumeroSerie).then((result) => {
          PreloaderGH(false);
          const paleParaReabrirFormateado = self.FormatearPropiedadesPale(result);
          self.$emit('reabrirPaleConfeccionadoEnPuntoDePaletizado', paleParaReabrirFormateado);
          self.CerrarMasPales();
        })
          .catch((error) => {
            PreloaderGH(false);
            HiNotification.Toast(error);
          });
      }
    },

    PaleEstablecidoMedianteBusqueda(paleBuscado) {
      Log(this, this.PaleEstablecidoMedianteBusqueda.name);

      this.paleSeleccionado = this.FormatearPropiedadesPale(paleBuscado);
      this.listadoPalesTotales = [];
      this.listadoPalesTotales.push(this.paleSeleccionado);
      this.filtroActivo = true;
    },

    FormatearPropiedadesPale(paleBuscado) {
      Log(this, this.FormatearPropiedadesPale.name);
      const tempProducto = paleBuscado.Existencias.find((e) => e.Articulo.TipoArticulo === 'Producto');
      const tempEnvase = paleBuscado.Existencias.find((e) => e.Articulo.TipoArticulo === 'Envase');
      const tempPale = paleBuscado.Existencias.find((e) => e.Articulo.TipoArticulo === 'Palet');

      if (tempPale === undefined || tempEnvase === undefined || tempProducto === undefined) {
        HiNotification.Toast(this.$t('production.lastGeneratedPallets.reopeningPallet.noStockToastText'));
        return null;
      }
      // Formateamos el palé
      const resultadoPale = {
        Id: paleBuscado.Id,
        NumeroSerie: paleBuscado.NumeroSerie,
        FechaFabricacion_NumeroSerie: paleBuscado.FechaFabricacion,
        NombreProducto: tempProducto.Articulo.Nombre,
        PedidoVenta_NombreCliente: (paleBuscado.PedidoVenta != null ? paleBuscado.PedidoVenta.Cliente.Nombre : ''),
        Articulo: tempProducto,
        Envase: tempEnvase,
        Pale: tempPale,
      };
      return resultadoPale;
    },

    EliminarFiltradoDePales() {
      Log(this, this.EliminarFiltradoDePales.name);
      this.filtroActivo = false;
      this.ActualizarListadoCompletoUltimosPalesGenerados();
    },

    LecturaDeCodigoDeBarrasBusquedaPale(codigo) {
      Log(this, this.LecturaDeCodigoDeBarrasBusquedaPale.name);
      this.ultimoCodigoDeBarrasLeido = codigo;
    },

    SolicitudEliminarPaleConfeccionado(pPale) {
      Log(this, this.SolicitudEliminarPaleConfeccionado.name);

      if (
        this.paleEnCurso
        && this.paleEnCurso.Id_NumeroSerie === pPale.Id_NumeroSerie
        && this.paleEnCurso.PaleReabierto
      ) {
        HiNotification.Toast(this.$t('production.lastGeneratedPallets.cannotDeleteReopenedPallet'));
        return;
      }

      this.$refs.componenteConfirmacionEliminarPale.create(
        this.$t('production.lastGeneratedPallets.deletePallet.title').toUpperCase(),
        this.$t('production.lastGeneratedPallets.deletePallet.text'),
        () => {
          this.paleSeleccionado = pPale;
          this.ConfirmacionEliminarPale();
        },
        this.paleSeleccionado = null,
      );
      this.$refs.componenteConfirmacionEliminarPale.show();
    },

    ConfirmacionEliminarPale() {
      Log(this, this.ConfirmacionEliminarPale.name);
      const self = this;
      if (this.paleSeleccionado != null) {
        PreloaderGH(true, false, this.$t('production.lastGeneratedPallets.deletePallet.preloaderText'));
        this.Conexion_EliminarPaleConfeccionado(this.paleSeleccionado.Id ? this.paleSeleccionado.Id : this.paleSeleccionado.Id_NumeroSerie).then(() => {
          PreloaderGH(false);
          self.ActualizarListadoCompletoUltimosPalesGenerados();
          self.ObtenerResumenPalesGenerados();
          HiNotification.Toast(self.$t('production.lastGeneratedPallets.deletePallet.successToastText'));
        })
          .catch((error) => {
            PreloaderGH(false);
            HiNotification.Toast(error);
          });
      } else {
        HiNotification.Toast(this.$t('production.lastGeneratedPallets.deletePallet.noPalletSelectedToastText'));
      }
    },

    ObtenerDetallesDelPale(numeroSeriePale) {
      Log(this, this.ObtenerDetallesDelPale.name);
      const self = this;
      return new Promise((resolve, reject) => {
        ConexionTA.callObtenePalePorNumeroDeSerie(numeroSeriePale, true, true, true).then((result) => {
          if (result.Valor) {
            const pale = JSON.parse(result.Mensaje);
            const mensaje = self.$t('production.lastGeneratedPallets.reopeningPallet.noStockSerialNumber');
            if (pale.Existencias.length === 0) {
              reject(mensaje);
            }
            resolve(pale);
          } else {
            reject(result.Mensaje);
          }
        })
          .catch((error) => {
            reject(error);
          });
      });
    },

    ImprimirEtiquetaPaleParaProcesoDePaletizado(idNumeroSeriePale) {
      Log(this, this.ImprimirEtiquetaPaleParaProcesoDePaletizado.name);
      return new Promise((resolve, reject) => {
        ConexionTA.callImprimirEtiquetaPaleParaProcesoDePaletizado(idNumeroSeriePale, this.puntoPaletizadoSeleccionado.Id).then((result) => {
          if (result.Valor) {
            resolve();
          } else {
            reject(result.Mensaje);
          }
        })
          .catch((error) => {
            reject(error);
          });
      });
    },

    ObtenerUltimosPalesConfeccionadosYEnConfeccion(numeroRegistrosObtener) {
      Log(this, this.ObtenerUltimosPalesConfeccionadosYEnConfeccion.name);
      return new Promise((resolve, reject) => {
        ConexionTA.callObtenerUltimosPalesConfeccionadosYEnConfeccion(this.puntoPaletizadoSeleccionado.Id, numeroRegistrosObtener).then((result) => {
          if (result.Valor) {
            const res = JSON.parse(result.Mensaje);
            [this.paleEnCurso] = res.PalesEnCurso;
            resolve(JSON.parse(result.Mensaje));
          } else {
            reject(result.Mensaje);
          }
        })
          .catch((error) => {
            LogError(this, this.ObtenerUltimosPalesConfeccionadosYEnConfeccion.name, error);
            reject(error);
          });
      });
    },

    Conexion_EliminarPaleConfeccionado(IdArticuloNumeroSerie) {
      Log(this, this.Conexion_EliminarPaleConfeccionado.name);
      return new Promise((resolve, reject) => {
        ConexionTA.callEliminarPaleConfeccionado(IdArticuloNumeroSerie).then((result) => {
          if (result.Valor) {
            resolve(JSON.parse(result.Mensaje));
          } else {
            reject(result.Mensaje);
          }
        })
          .catch((error) => {
            LogError('error');
            reject(error);
          });
      });
    },
  },
};
</script>

<style scoped lang="scss">
.main-ultimosPalesGenerados {
  padding: none;

  .div-registroPaleActivo {
    background: #fff;
    border-bottom: 1px solid var(--his-disabled);
  }

  .div-listadoPalesFinalizadosYPendientes {
    margin: 22px;
    margin-bottom: 5px;
    margin-top: 10px;
    max-height: 100%;
    height: 54vh;
  }

  .btn-opcionesMultiplePale {
    margin-left: 12px;
  }

  .btn-EliminarFiltradoDePales {
    margin-left: auto;
  }
}

.div-registroPale {
  padding-top: 8px;
  padding-left: 5px;
  padding-right: 5px;
  background: #fafbfc;
  border-bottom: 1px solid var(--his-disabled);
}

.row-registroPale {
  display: flex;
  align-items: flex-start;

  .col-indicadorEstadoPale {
    padding-top: 5px;
  }
}

.div-horaRegistroMovimiento {
  // border: 1px solid #009ba6;
  // background: rgba(0, 155, 166, 0.1);
  // border: 1px solid #009ba6;
  border-radius: 35px;
  display: flex;
  align-items: center;
  justify-content: center;

  // color: #009ba6;
  font-size: 14px;
  font-weight: 400;
  line-height: 14px;
  max-width: max-content;
  min-width: max-content;
  min-height: 17px;
  padding: 2px 7px;
}

.col-btnsOpcionesPale {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 10px;
}

.col-horaFinPale {
  text-align: -webkit-right;
  margin-right: 5px;
}

.masPartidasVolcadas-popup {
  overflow: hidden;

  .div-cabeceraFiltroActivo {
    background: lightgray;
    padding-left: 30px;
    padding-top: 15px;
    padding-bottom: 15px;
    padding-right: 20px;
    display: flex;
  }

  .div-ultimosPales {
    height: calc(100% - 133px - 70px - 10px);
    overflow-y: scroll;
  }
}
</style>
